import { render, staticRenderFns } from "./mq_message_send.vue?vue&type=template&id=f3bb3ff6&scoped=true"
import script from "./mq_message_send.vue?vue&type=script&lang=js"
export * from "./mq_message_send.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bb3ff6",
  null
  
)

export default component.exports